import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a48dec06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-strategy-card" }
const _hoisted_2 = { class: "terminal-strategy-card__main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "terminal-strategy-card__label" }, "签署终端人员合同", -1))
const _hoisted_4 = { class: "terminal-strategy-card__actions" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auto-sign-btn__dot" }, null, -1))
const _hoisted_6 = { class: "auto-sign-btn__state" }

import { computed, onMounted, ref } from 'vue';
import {
  BaseSwitch,
  BaseButton,
  BaseIcon,
  BaseTag,
  BaseInput,
  XrkMessage
} from 'xrk-components';
import { Document } from '@element-plus/icons-vue';

import {
  getTerminalSignStrategy,
  saveTerminalSignStrategy,
  type TerminalSignStrategy
} from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-strategy-card',
  emits: ["go-template"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const DEFAULT_STRATEGY: TerminalSignStrategy = {
  signTerminalContract: null,
  isAutoSign: 0,
  marketServicePersonTemplate: {
    id: 0,
    contractTemplateName: ''
  }
};

const strategy = ref<TerminalSignStrategy>({ ...DEFAULT_STRATEGY });
const loading = ref(false);
const autoSignSaving = ref(false);

const signTerminalOn = computed(() => !!strategy.value.signTerminalContract);

/** 拉取签约策略 */
const fetchStrategy = async () => {
  loading.value = true;
  try {
    const { data } = await getTerminalSignStrategy();
    strategy.value = { ...DEFAULT_STRATEGY, ...data };
  } finally {
    loading.value = false;
  }
};

onMounted(fetchStrategy);

/** 开关：签署终端人员合同 */
const onToggleTerminal = async strategy => {
  console.log(strategy, 'vvvv');
  return new Promise((resolve, reject) => {
    saveTerminalSignStrategy({
      signTerminalContract: +!strategy.signTerminalContract as 0 | 1
    })
      .then(() => {
        XrkMessage.success(
          +!strategy.signTerminalContract
            ? '已开启签署终端人员合同'
            : '已关闭签署终端人员合同'
        );
        resolve(true);
      })
      .catch(() => {
        reject(false);
      });
  });
};

/** 自动签署切换 */
const onToggleAutoSign = async () => {
  const next = strategy.value.isAutoSign ? 0 : 1;
  await saveTerminalSignStrategy({ isAutoSign: next });
  XrkMessage.success(!next ? '已开启自动签署' : '已关闭自动签署');
  strategy.value.isAutoSign = next;
};

__expose({
  refresh: fetchStrategy
});

return (_ctx: any,_cache: any) => {
  const _directive_xrk_loading = _resolveDirective("xrk-loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BaseSwitch), {
        "active-value": 1,
        "inactive-value": 0,
        modelValue: strategy.value.signTerminalContract,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.signTerminalContract) = $event)),
        "before-change": 
          async () => {
            await onToggleTerminal(strategy.value);
          }
        
      }, null, 8, ["modelValue", "before-change"]),
      _hoisted_3,
      _createVNode(_unref(BaseTag), {
        effect: "plain",
        type: signTerminalOn.value ? 'warning' : 'danger',
        class: "terminal-strategy-card__badge"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(signTerminalOn.value ? '需签署' : '免签署'), 1)
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_unref(BaseInput), {
        disabled: "",
        "model-value": strategy.value.marketServicePersonTemplate.contractTemplateName
      }, null, 8, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('go-template')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseIcon), {
            size: "14",
            style: {"margin-right":"4px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Document))
            ]),
            _: 1
          }),
          _createTextVNode(" 合同模版 ")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: !strategy.value.isAutoSign ? 'primary' : 'default',
        class: _normalizeClass(["auto-sign-btn", { 'auto-sign-btn--on': strategy.value.isAutoSign }]),
        loading: autoSignSaving.value,
        click: onToggleAutoSign
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" 自动签署 "),
          _createElementVNode("span", _hoisted_6, _toDisplayString(!strategy.value.isAutoSign ? '已开启' : '未开启'), 1)
        ]),
        _: 1
      }, 8, ["type", "class", "loading"])
    ])
  ])), [
    [_directive_xrk_loading, loading.value]
  ])
}
}

})